export const SET_BANK_LIST = 'SET_BANK_LIST'
export const SET_REGION_COUNTRY = 'SET_REGION_COUNTRY'
export const SET_CITY = 'SET_CITY'
export const SET_AREA = 'SET_AREA'
export const SET_REGION_LIST = 'SET_REGION_LIST'
